import * as React from "react";

const SvgKomb = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200.66"
    fill="none"
    viewBox="0 0 120 70"
    {...props}
  >
   
    <path fill={rackColor} d="M0 0h120v70H0z" />
    <path
      fill="none"
      stroke="black"
      strokeWidth="0.8"
      d="M0 0h120v70H0z"    />
    <path fill="#D7EAFF" d="M5 5h110v35H5z" />
  </svg>
);

export default SvgKomb;
